import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { BurnCenterRoutes } from 'helpers/routes';

import { UserAdd, UserEdit } from 'components/forms/UserAdd';
import DetailPage from './detail';

const BurnCenter: React.FC = () => (
  <Routes>
    <Route index element={<Navigate replace to={BurnCenterRoutes.DETAIL} />} />
    <Route path={`${BurnCenterRoutes.DETAIL}/*`} element={<DetailPage />} />
    <Route path={`${BurnCenterRoutes.DETAIL}/new`} element={<UserAdd />} />
    <Route path={`${BurnCenterRoutes.DETAIL}/:userId/*`} element={<UserEdit />} />
  </Routes>
);

export default BurnCenter;
